import type { SaveBarProps } from "./save-bar.type";

import { Spin } from "antd";

import { SaveBarButtons } from "./save-bar-buttons";
import { SaveBarIcon } from "./save-bar-icon";
import { SaveBarMessage } from "./save-bar-message";
import { getSaveBarStatus } from "./save-bar.helper";

import "./save-bar.style.less";

export const SaveBar = ({
  loading = false,
  sticky = false,
  hasChanges,
  date,
  onSave,
  onCancel,
}: SaveBarProps) => {
  const status = getSaveBarStatus(hasChanges);

  return (
    <Spin spinning={loading}>
      <div
        aria-busy={loading}
        role={loading ? "status" : undefined}
        aria-live={loading ? "polite" : undefined}
        className={`save-bar-wrapper ${sticky ? "sticky" : ""}`}
      >
        <div className={`save-bar ${status}`}>
          <SaveBarIcon status={status} />
          <SaveBarMessage hasChanges={hasChanges} date={date} />
          <SaveBarButtons
            hasChanges={hasChanges}
            disabled={loading}
            onCancel={onCancel}
            onSave={onSave}
          />
        </div>
      </div>
    </Spin>
  );
};
